<template>
    <div class="flex relative my-auto container mx-auto">

      <PrevArrow prev="sub-offer-four"/>

      <div class="subsection-big-circle bg-black rounded-full mx-auto">
        <h1 class="deep-info-sub-heading text-white mx-auto pt-20 text-2xl font-bold">INTRINSIC <br>AI</h1>
        <p class="text-teal mt-8 text-4xl font-bold leading-tight">BETTER <br>AND DEEPER <br>DATA</p>
      </div>

      <NextArrow next="sub-offer-six"/>

    </div>
</template>

<script>
import PrevArrow from "@/components/deepinfo/subnavigation/PrevArrow.vue";
import NextArrow from "@/components/deepinfo/subnavigation/NextArrow.vue";

export default {
  name: "OfferSubFive",
  components:{
    PrevArrow,
    NextArrow
  }
}
</script>
